import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=45e9d1e4&scoped=true&"
import script from "./Transaction.vue?vue&type=script&lang=js&"
export * from "./Transaction.vue?vue&type=script&lang=js&"
import style0 from "./Transaction.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Transaction.vue?vue&type=style&index=1&id=45e9d1e4&lang=scss&scoped=true&"
import style2 from "./Transaction.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e9d1e4",
  null
  
)

export default component.exports